import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ConfiguracionPage from './pages/ConfiguracionPage';
import UsuariosPage from './pages/UsuariosPage';
import FamiliaProductosPage from './pages/FamiliaProductosPage';
import MarcasPage from './pages/MarcasPage';
import AlmacenesPage from './pages/AlmacenesPage';
import MovimientosPage from './pages/MovimientosPage';
import TransferenciasPage from './pages/TransferenciasPage';
import StockPage from './pages/StockPage';
import ProductosPage from './pages/ProductosPage';
import ClientesPage from './pages/ClientesPage';
import ProveedoresPage from './pages/ProveedoresPage';
import ComprasPage from './pages/ComprasPage';
import CuentasPagarPage from './pages/CuentasPagarPage';
import VentasPage from './pages/VentasPage';
import CotizacionesPage from './pages/CotizacionesPage';
import CuentasCobrarPage from './pages/CuentasCobrarPage';
import CajasPage from './pages/CajasPage';
import CajaAperturaPage from './pages/CajaAperturaPage';
import CajaHistorialPage from './pages/CajaHistorialPage';
import PerfilesPage from './pages/PerfilesPage';
import ProximamentePage from './pages/ProximamentePage';
import VentaImprimirPage from './pages/VentaImprimirPage';
import CotizacionImprimirPage from './pages/CotizacionImprimirPage';
import VentaDespachoPage from './pages/VentaDespachoPage';
import ReportesPage from './pages/ReportesPage';
import ReporteImprimirPage from './pages/ReporteImprimirPage';
import CajaCuadreImprimirPage from './pages/CajaCuadreImprimirPage';
import ToastContainer from './components/ToastContainer';
import './styles/App.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Componente interno: tiene acceso al contexto de auth para leer business_id
function AppRoutes() {
  const { user, empresa } = useAuth();
  const bizId = user?.business_id || 1;

  // Aplica fondo_general dinámicamente sin tocar Layout.jsx (fallback a fondo_layout.png)
  useEffect(() => {
    const url = empresa?.fondo_general
      ? `url(${API_URL}${empresa.fondo_general})`
      : `url(${process.env.PUBLIC_URL}/fondo_layout.png)`;
    document.documentElement.style.setProperty('--fondo-general-url', url);
  }, [empresa?.fondo_general]);
  return (
    <Routes>
      <Route path="/"         element={<Dashboard businessId={bizId} />} />
      <Route path="/config/*" element={<ConfiguracionPage businessId={bizId} />} />
      <Route path="/usuarios"           element={<UsuariosPage />} />
      <Route path="/familia-productos"  element={<FamiliaProductosPage />} />
      <Route path="/marcas"             element={<MarcasPage />} />
      <Route path="/almacenes"          element={<AlmacenesPage />} />
      <Route path="/movimientos"        element={<MovimientosPage />} />
      <Route path="/transferencias"     element={<TransferenciasPage />} />
      <Route path="/stocks"             element={<StockPage />} />
      <Route path="/productos"          element={<ProductosPage />} />
      <Route path="/clientes"           element={<ClientesPage />} />
      <Route path="/proveedores"        element={<ProveedoresPage />} />
      <Route path="/compras"            element={<ComprasPage />} />
      <Route path="/cuentas-pagar"      element={<CuentasPagarPage />} />
      <Route path="/cajas"              element={<CajasPage />} />
      <Route path="/caja/apertura"      element={<CajaAperturaPage />} />
      <Route path="/caja/historial"     element={<CajaHistorialPage />} />
      <Route path="/cotizaciones"   element={<CotizacionesPage />} />
      <Route path="/ventas"         element={<VentasPage />} />
      <Route path="/cuentas-cobrar" element={<CuentasCobrarPage />} />
      <Route path="/reportes"       element={<ReportesPage />} />
      <Route path="/perfiles"       element={<PerfilesPage />} />
      <Route path="/empresas"       element={<ProximamentePage />} />
      <Route path="*"         element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastContainer />
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/print-venta/:id" element={<VentaImprimirPage />} />
          <Route path="/print-cotizacion/:id" element={<CotizacionImprimirPage />} />
          <Route path="/print-despacho/:id" element={<VentaDespachoPage />} />
          <Route path="/print-reporte/:tipo" element={<ReporteImprimirPage />} />
          <Route path="/print-cuadre/:id" element={<CajaCuadreImprimirPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <AppRoutes />
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
